import React from "react";
import RouterAllPages from "./Pages/4.RouterAllPages/RouterAllPages";
import "./App.css"




function  App() {
  
  return (
    <>
    <RouterAllPages/>
    </>
  );
}

export default  React.memo( App);
